'use strict'

import api from '@/api/api';
import jwt from 'jwt-simple';

const clave = 'fanosa-app2021-0x';
const SET_TOKEN     = 'SET_TOKEN',
      SET_IDENTITY  = 'SET_IDENTITY',
      SET_SURVEY  = 'SET_SURVEY',
      SET_STATUS  = 'SET_STATUS',
      SET_PROD     = 'SET_PROD',
      SET_BONOS  = 'SET_BONOS',
      SET_HISTORIAL  = 'SET_HISTORIAL';

export default {
    namespaced: true,
    state:{
        token: '',
        identity: { },
        survey:'',
        prodColab:[],
        bonosColab:[],
        historial:[],
        statusSurvey:'',
    },
    getters: {
        getToken(state){
            return state.token;
        },
        getSurvey(state){
            return state.survey;
        },
        getStatusSurvey(state){
            return state.statusSurvey;
        },
        getIdentity(state){
            return state.identity;
        },
        getProdColab(state){
            return state.prodColab;
        },
        getBonosColab(state){
            return state.prodColab;
        },
        getHistorial(state){
            return state.historial;
        }
    },
    mutations: {
        [SET_TOKEN](state, payload){
            state.token = payload;
        },
        [SET_IDENTITY](state, payload){
            state.identity = payload;
        },
        [SET_SURVEY](state, payload){
            state.survey = payload;
        },
        [SET_STATUS](state, payload){
            state.statusSurvey = payload;
        },
        [SET_PROD](state, payload){
            state.prodColab = payload;
        },
        [SET_BONOS](state, payload){
            state.bonosColab = payload;
        },
        [SET_HISTORIAL](state, payload){
            state.historial = payload;
        }
    },
    actions:{
        async login({commit}, payload) {
            let email = payload.email,
                password = payload.password, 
                gettoken = payload.gettoken;

            if (gettoken != null) {
                gettoken = "true";
            }
            const user = { email, password, gettoken };
            try {
                let headers = { "Content-Type": "application/x-www-form-urlencoded" };
                let response = await api.login(user, headers);
                
                commit(SET_TOKEN, response.data.token);
                return response;
            } catch (error) {
                ////console.log(error)
            }
        },
        async resendCode({commit}, payload) {
                let email = payload.email,
                name = payload.name, 
                code = payload.code;
            const user = { email, name, code };
            try {
                let headers = { "Content-Type": "application/x-www-form-urlencoded" };
                let response = await api.resendCode(user, headers);
    
                return response;
            } catch (error) {
                ////console.log(error)
            }
        },
        async sendPass({commit}, payload) {
          
        try {
            let headers = { "Content-Type": "application/x-www-form-urlencoded" };
            let response = await api.sendPass(payload, headers);

            return response;
        } catch (error) {
            ////console.log(error)
        }
    },
        setToken({commit}, token) {
            localStorage.setItem("token", token);
            commit(SET_TOKEN, token);
        },
        setSurvey({commit}, survey) {
           
            commit(SET_SURVEY, survey);
        },
        setStatusSurvey({commit}, status) {
          
            commit(SET_STATUS, status);
        },
        getToken({commit}) {
            let userToken = "";
            let token = localStorage.getItem("token");
            if (token && token != "undefined") {
              userToken = token;
            } else {
              userToken = null;
            }
            commit(SET_TOKEN, userToken);
            return userToken;
        },
        decode({commit}, token){
            let decoded;
            let user = {};

            if(token != null){
             decoded = jwt.decode(token, clave);
             user = decoded; 
             commit(SET_IDENTITY, user);
            }            
            return user;
        },
        logout({commit}) {            
            localStorage.removeItem('token');
            localStorage.removeItem('survey');
            localStorage.removeItem('min');
            if(localStorage.getItem("ath") != null){localStorage.removeItem('ath');}            
            commit(SET_IDENTITY, null);
            commit(SET_TOKEN, null);            
      },
      async getProduccionColab({commit}, payload){
        let response;
        try{
            let num = payload;
            response = await api.getProduccionColab(num);
          
            commit(SET_PROD, response.data.reporte);
            return response.data.reporte
           
        }catch(error){
            //console.log(error);
        }
    },
    async getBonosColab({commit}, payload){
        let response;
        try{
            let num = payload;
            response = await api.getBonosColab(num);
          
            commit(SET_BONOS, response.data.reporte);
            return response.data.reporte
           
        }catch(error){
            //console.log(error);
        }
    },
    async getHistorial({commit}, payload){
        let responseBonos, responseProd;
        let htrl = [];
        let num = payload.user;
        let city = payload.city;
        let depto = payload.depto;
        //console.log(payload)
        try{
            if(depto != 'mantenimiento' && depto != 'vigueta'  && depto != 'bonogarantia'  && depto != 'insulpanel'){
                responseBonos = await api.getBonosColab(num);
                responseProd = await api.getProduccionColab(num);

                let bonos = responseBonos.data.reporte;
                let prod = responseProd.data.reporte;
                let lenp = prod.length;
                let lenb = bonos.length;

                if (lenp > 0 && lenb > 0) {
                  for (var i = 0; i < lenp; i++) {
                    let model = {
                      bono: bonos[i].bono,
                      prod: prod[i].produccion,
                      semana: bonos[i].descrp,
                    };
                    htrl.push(model);
                  }
                }
                commit(SET_HISTORIAL, htrl);
                return htrl

            }else{
                responseBonos = await api.getBonosColab(num);
             
                let bonos = responseBonos.data.reporte;
                let lenb =bonos.length;

                if ( lenb > 0) {
                  for (var i = 0; i < lenb; i++) {
                    let model = {
                      bono: bonos[i].bono,
                      semana: bonos[i].descrp,
                    };
                    htrl.push(model);
                  }
                }
                commit(SET_HISTORIAL, htrl);
                return htrl
            }
       

            //validar departamentos que no ocupan prod.
          
           
        }catch(error){
            ////console.log(error)
        }
    },
    }
}